import { memo } from 'react';
import { H3, Img } from '../../../library';
import errorWebcam from '../../../img/error-webcam.png';
import styled, { css } from 'styled-components';
import { node, string } from 'prop-types';
import { Box } from 'rebass/styled-components';

export const TechTextContent = styled.div`
	font-size: 13px;
	margin: 0 auto;
	line-height: 21px;
	text-align: left;
	padding: 20px;
	width: 100%;
	max-width: 800px;
	${({ theme }) => css`
		${theme.mediaQueries.large} {
			padding: 30px;
			ul {
				padding-left: 20px;
			}
		}
	`};
	background-color: #f4f6f8;
	border: 1px solid #666d7c;
	border-radius: 5px;
	ul {
		padding-left: 10px;
		li {
			margin-bottom: 5px;
		}
	}
`;

const BlocError = memo(({ title, children, button }) => (
	<Box mb={4} pl={[0, 0, '30px', 0]} pr={[0, 0, '30px', 0]}>
		<H3 textAlign="center" fontSize="18px" p="8px">
			<Img alt="icon troubleshooting" marginRight="20px" width="45px" src={errorWebcam} />
			{title}
		</H3>
		<TechTextContent>{children}</TechTextContent>
		{button}
	</Box>
));

BlocError.propTypes = {
	title: string,
	children: node,
	button: node,
};

export default BlocError;
